import { jsx as e, jsxs as i, Fragment as u } from "react/jsx-runtime";
import { Icon as E, MenuItem as s, MenuDivider as k } from "@blueprintjs/core";
import { IconNames as p } from "@blueprintjs/icons";
import { MainNavBar as v, MainNavBarMobile as z } from "@strata/react-main-navbar";
import { NotificationsDropdownMenu as O } from "@strata/react-notifications";
import { useState as M, useEffect as V } from "react";
import { useResizeDetector as j } from "react-resize-detector";
import { Link as G } from "react-router-dom";
import { openInNewTab as U } from "@strata/helper-functions";
import { DropdownMenu as w } from "@strata/react-dropdown-menu";
import { saveCookie as B, getCookie as F } from "@strata/cookies";
import { ToggleButton as Y } from "@strata/react-buttons";
import "./main.scss";
const $ = () => /* @__PURE__ */ e(
  w,
  {
    menuItemArray: [
      {
        icon: p.SHARE,
        text: "Knowledge Center",
        onItemClick: () => U("https://www.freemarkethealth.com/knowledge-center")
      }
    ],
    children: /* @__PURE__ */ e(
      E,
      {
        icon: p.LEARNING,
        title: "Knowledge Center",
        size: 20,
        style: { cursor: "pointer" }
      }
    )
  }
), g = "APP_THEME", c = "theme--sds_dark", C = "theme--sds_light", x = (o) => {
  o ? (document.body.classList.add(c), document.body.classList.remove(C)) : (document.body.classList.add(C), document.body.classList.remove(c));
}, q = () => {
  const o = F(g);
  if (o) {
    const n = o === c;
    return x(n), n;
  }
  return document.body.classList.contains(c);
}, J = ({
  showProfileDropdown: o = !1,
  onProfileClick: n = void 0,
  afterProfileMenuItems: d = void 0,
  onNotificationSettingsClick: l = void 0,
  onLogOutClick: _ = void 0,
  onTermsOfUseClick: a = void 0,
  onPrivacyPolicyClick: m = void 0,
  appVersion: h = void 0
}) => {
  const [r, f] = M(q());
  return V(() => {
    x(r), B(g, r ? c : C, 365);
  }, [r]), o ? /* @__PURE__ */ e(
    w,
    {
      menuContent: /* @__PURE__ */ i(u, { children: [
        n && /* @__PURE__ */ e(s, { text: "View Profile", onClick: n }),
        d == null ? void 0 : d.map((t) => /* @__PURE__ */ e(
          s,
          {
            icon: t.icon,
            text: t.text,
            labelElement: t.labelElement,
            onClick: t.onItemClick,
            disabled: t.disabled,
            intent: t.intent
          },
          t.text
        )),
        l && /* @__PURE__ */ e(
          s,
          {
            text: "Notification Settings",
            onClick: l
          }
        ),
        /* @__PURE__ */ i("div", { style: { display: "flex", alignItems: "center", paddingLeft: 7 }, children: [
          "Dark Mode",
          /* @__PURE__ */ e(
            Y,
            {
              onChange: (t) => f(t.target.checked),
              isOn: r
            }
          )
        ] }),
        a && m && /* @__PURE__ */ i(u, { children: [
          /* @__PURE__ */ e(k, {}),
          /* @__PURE__ */ e(s, { text: "Terms of Use", onClick: a }),
          /* @__PURE__ */ e(s, { text: "Privacy Policy", onClick: m }),
          h && /* @__PURE__ */ e(s, { text: `Version ${h}`, disabled: !0 })
        ] }),
        /* @__PURE__ */ e(k, {}),
        /* @__PURE__ */ e(s, { text: "Log Out", onClick: _ })
      ] }),
      children: /* @__PURE__ */ e(E, { icon: p.USER, title: "Profile", size: 20, style: { cursor: "pointer" } })
    }
  ) : null;
}, P = ({
  navBar: o = void 0,
  showNotifications: n = !1,
  notifications: d,
  incomingNotification: l,
  NotificationComponentMap: _,
  onNotificationClick: a,
  onRemoveNotificationClick: m,
  onClearAllNotificationsClick: h,
  onNotificationsDropdownClose: r,
  showKnowledgeCenterDropdown: f = !1,
  appVersion: t,
  showProfileDropdown: D = !0,
  onNotificationSettingsClick: N,
  onProfileClick: T,
  onLogOutClick: L,
  onTermsOfUseClick: y,
  onPrivacyPolicyClick: I,
  afterProfileMenuItems: S
}) => {
  const { width: A, ref: H } = j(), R = 768, [K, b] = M(!1);
  return /* @__PURE__ */ i("div", { className: "theme--sds_dark sds_header__container", ref: H, children: [
    (A ?? 0) < R && o ? /* @__PURE__ */ i(u, { children: [
      /* @__PURE__ */ e(
        E,
        {
          icon: p.MENU,
          size: 20,
          className: "sds_header__icon",
          title: "Menu",
          onClick: () => b(!0)
        }
      ),
      /* @__PURE__ */ e(
        z,
        {
          navTabContent: o,
          isOpen: K,
          onMobileMenuClose: () => b(!1)
        }
      )
    ] }) : /* @__PURE__ */ i(u, { children: [
      /* @__PURE__ */ e(G, { to: "/home", children: /* @__PURE__ */ e("div", { className: "sds_header__logo" }) }),
      o && /* @__PURE__ */ e("div", { className: "sds_header__tabs", children: /* @__PURE__ */ e(v, { navTabContent: o }) })
    ] }),
    /* @__PURE__ */ i("div", { className: "sds_header__icons", children: [
      n && /* @__PURE__ */ e(
        O,
        {
          notifications: d,
          incomingNotification: l,
          NotificationComponentMap: _,
          onNotificationClick: a,
          onRemoveNotificationClick: m,
          onClearAllNotificationsClick: h,
          onNotificationsDropdownClose: r
        }
      ),
      f && /* @__PURE__ */ e($, {}),
      /* @__PURE__ */ e(
        J,
        {
          showProfileDropdown: D,
          onProfileClick: T,
          afterProfileMenuItems: S,
          onNotificationSettingsClick: N,
          onLogOutClick: L,
          onTermsOfUseClick: y,
          onPrivacyPolicyClick: I,
          appVersion: t
        }
      )
    ] })
  ] });
};
P.DIVIDER = v.DIVIDER;
export {
  P as Header
};
//# sourceMappingURL=index.js.map
